import { createBrowserRouter } from "react-router-dom";
import GuestLayout from "./components/Layouts/Guest";
import Login from "./components/Connexion/Login/Login";
import Register from "./components/Connexion/Register/Register";
import Function from "./components/Layouts/Fonction";
import Catalogue from "./components/CFP/Accueilcatalogue/catalogue";
import Index from "./components/CFP/Accueil/index";
import EtpCatalogue from "./components/ETP/AccueilETP/Accueiletp";
import DetailModule from "./components/CFP/DetailModule/DetailModule";
import Preparation from "./components/CFP/Préparation/Preparation";
import Corbeille from "./components/CFP/Corbeille/Corbeille";
import CorbeilleEtp from "./components/ETP/CorbeilleEtp/CorbeilleEtp";
import PreparationEtp from "./components/ETP/PreparationEtp/PreparationEtp";
import FunctionEtp from "./components/Layouts/FonctionEtp";
import DetailModuleEtp from "./components/ETP/DetailModuleEtp/DetailModuleEtp";
import PrivateRoute from "./Context/PrivateRoute";
import FormafusionSignup from "./component/FormafusionSignup";


const router = createBrowserRouter([
  {
    path: "/",
    element: <GuestLayout />,
    children: [
      {
        path: "",
        element: <Index />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/register",
        element: <FormafusionSignup/>
      },

    ],
  },

  {
    path: "/",
    element: (
      <PrivateRoute>
        <Function />
      </PrivateRoute>
    ),
    children: [
      {
        path: "cfp/catalogue",
        element: <Catalogue />,
      },
      {
        path: "/:id/edit",
        element: <DetailModule />
      },
      {
        path: "cfp/catalogue/preparation",
        element: <Preparation />
      },
      {
        path: "cfp/catalogue/corbeille",
        element: <Corbeille />
      },
    ],
  },

  //route ETP
  {
    path: "/",
    element: (
      <PrivateRoute>
        <FunctionEtp />,
      </PrivateRoute>
    ),
    children: [
      {
        path: "etp/catalogue",
        element: <EtpCatalogue />,
      },
      {
        path: "/etp/catalogue/:id/edit",
        element: <DetailModuleEtp />
      },
      {
        path: "etp/catalogue/corbeilleetp",
        element: <CorbeilleEtp />
      },
      {
        path: "etp/catalogue/preparationetp",
        element: <PreparationEtp />
      },


    ],
  },

]);

export default router;
